import React from 'react';
import { motion } from 'framer-motion';
import { MachhaCharacter } from '../../lib/machhaAsset';
import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClassMap = {
  sm: styles['size-sm'],
  md: styles['size-md'],
  lg: styles['size-lg'],
};

export function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  return (
    <div className={[styles.root, sizeClassMap[size], className].filter(Boolean).join(' ')}>
      <motion.svg className={styles.track} fill="none" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
      </motion.svg>
      <motion.svg
        className={styles.arc}
        fill="none"
        viewBox="0 0 24 24"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 0.85, ease: 'linear' }}
      >
        <path
          style={{ opacity: 0.8 }}
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </motion.svg>
      <motion.div
        className={styles.dot}
        animate={{ scale: [0.8, 1.2, 0.8], opacity: [0.4, 1, 0.4] }}
        transition={{ repeat: Infinity, duration: 1.6, ease: 'easeInOut' }}
      >
        <div className={styles['dot-inner']} />
      </motion.div>
    </div>
  );
}

export function FullPageSpinner() {
  return (
    <div className={styles['full-page']}>
      <motion.div
        className={styles.blob}
        animate={{ scale: [1, 1.08, 1], opacity: [0.6, 1, 0.6] }}
        transition={{ repeat: Infinity, duration: 6, ease: 'easeInOut' }}
      />
      <motion.p
        className={styles['loading-text']}
        initial={{ opacity: 0, y: -6 }}
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      >
        Getting things ready…
      </motion.p>
      <motion.div
        className={styles.character}
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: [14, 0, 14], opacity: 1 }}
        transition={{
          y: { repeat: Infinity, duration: 2.6, ease: 'easeInOut' },
          opacity: { duration: 0.5 },
        }}
      >
        <MachhaCharacter state="Loading" size={220} />
      </motion.div>
    </div>
  );
}
